/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextInputField } from "@/components/custom/InputField/TextInputField"
import { DatePickerInputField } from "@/components/custom/InputField/DatePickerInput"
import { UseFormReturn } from "react-hook-form"
import { z } from "zod"

export const DynamicFieldRenderer = ({
  form,
  attributeName,
  displayName,
  type,
  isDisabled,
  schema,
  description,
  placeholder,
}: {
  form: UseFormReturn<any>;
  attributeName: string;
  displayName: string;
  type?: string;
  isDisabled: boolean;
  schema: z.ZodObject<any>;
  description: string
  placeholder?: string
}) => {
  if (attributeName.toLowerCase().includes("date")) {
    return (
      <div className="text-left">
        <DatePickerInputField
          form={form}
          schema={schema}
          name={attributeName}
          description={description}
          label={displayName}
          isDisabled={isDisabled}
          className="w-[400px]"
        />
      </div>
    )
  }

  return (
    <TextInputField
      form={form}
      schema={schema}
      name={attributeName}
      label={displayName}
      type={type === "password" ? "password" : "text"}
      error={!!form.formState.errors[attributeName]}
      required={true}
      isDisabled={isDisabled}
      description={description}
      placeholder={placeholder}
    />
  )
}
